export class NoActionLayout {
    prepareFromGraph(graph, _configurations) {
        this.graph = graph;
    }
    ;
    run() {
        console.info("Running NoActionLayout");
        return Promise.resolve(this.graph.mainGraph);
    }
    ;
    runGeneralizationLayout() {
        return Promise.resolve(this.graph.mainGraph);
    }
    ;
    graph;
}
//# sourceMappingURL=no-action-layouts.js.map